<script lang="ts">
	import classnames from 'classnames';
	import { onMount, onDestroy } from 'svelte';
	import { createRoot } from 'react-dom/client';
	import React from 'react';
	import PhoneInput from 'react-phone-input-2';
	import 'react-phone-input-2/lib/style.css';
	import it from 'react-phone-input-2/lang/es.json';
	import { isValidPhoneNumber } from 'libphonenumber-js';

	export let value = '';
	export let disabled = false;
	export let isValid: boolean = true;
	export let isEmpty: boolean = false;
	let touched = false;
	let focused = value.length > 0;

	if (value && !value.startsWith('+39')) {
		if (value.startsWith('39')) {
			value = `+${value}`;
		} else {
			value = `+39${value.replace(/^(\+)?/, '')}`;
		}
	}

	let container: HTMLElement;
	let root: any;

	onMount(() => {
		root = createRoot(container);

		root.render(
			React.createElement(PhoneInput, {
				localization: it,
				country: 'it',
				regions: 'europe',
				value,
				inputClass: 'text-field',
				placeholder: '',
				specialLabel: 'Telefono',
				countryCodeEditable: true,
				disabled,
				onFocus: () => {
					focused = true;
				},
				onBlur: (e: any, country: any) => {
					let code = `+${country.dialCode}`;
					if (value === code || value.length < code.length) {
						focused = false;
					}
				},
				onChange: (val: string) => {
					touched = true;
					value = `+${val}`;
				},
				isValid: (inputNumber: string, country: any) => {
					if (inputNumber === country?.dialCode) {
						isValid = true;
						isEmpty = true;
						return true;
					}
					const isoCode = country?.iso2?.toUpperCase?.();
					isValid = isValidPhoneNumber(`+${inputNumber}`, isoCode);
					isEmpty = false;
					return isValidPhoneNumber(`+${inputNumber}`, isoCode);
				}
			})
		);
	});

	onDestroy(() => {
		if (root) {
			root.unmount();
		}
	});
</script>

<div class={classnames(`text-field-floating ${focused && 'focused'}`, $$props.class)}>
	<div bind:this={container} />
	{#if touched && isEmpty}
		<span class="error">Inserisci il tuo numero di telefono</span>
	{/if}
	{#if !isValid}
		<span class="error">Il numero di telefono non è valido</span>
	{/if}
</div>

<style type="text/scss" lang="scss" scoped>
	.text-field-floating {
		@apply relative mb-3;
	}

	:global(.text-field-floating .text-field) {
		@apply w-full outline-none shadow-none focus:outline-none focus:shadow-none focus:ring-0;
		@apply border-0 border-b border-gray-600 focus:border-brand rounded-none;
		@apply h-11 px-4 py-2 pl-12;

		&::placeholder {
			@apply text-transparent;
		}

		&:focus,
		&:not(:placeholder-shown) {
			@apply pt-6 pb-2.5;

			+ .special-label {
				@apply scale-80 -translate-y-3 translate-x-px;
			}
		}

		&:-webkit-autofill {
			@apply pt-6 pb-2.5;
		}
	}

	// :global(.text-field-floating .special-label) {
	// 	@apply absolute left-[5.5rem] inline text-base h-full overflow-hidden truncate;
	// 	@apply px-4 py-2.5 pt-4 pl-0 border border-transparent opacity-50;
	// 	@apply transform origin-left transition-transform duration-300 pointer-events-none;
	// }
	:global(.text-field-floating .special-label) {
		@apply absolute left-[5.5rem] inline text-base h-full overflow-hidden truncate;
		@apply scale-80 -translate-y-2 -translate-x-18 px-1 pb-0 transition-all duration-300 ease-in-out bg-opacity-0;
		@apply flex h-8 p-0 items-end top-0;
		@apply border border-transparent opacity-50;
		@apply transform origin-left transition-transform duration-300 pointer-events-none;
	}
	:global(.text-field-floating .react-tel-input .form-control) {
		@apply pl-14;
	}
	:global(.text-field-floating .react-tel-input .form-control.invalid-number) {
		@apply border-0 border-b border-gray-600 bg-transparent;
	}

	:global(.text-field-floating .react-tel-input .flag-dropdown) {
		@apply flex items-end ml-3;
		@apply border-none rounded-none bottom-px bg-transparent;
	}

	:global(.text-field-floating .react-tel-input .selected-flag) {
		@apply h-7 bottom-px;
	}

	.hint {
		@apply text-xs;
	}

	.error {
		@apply text-xs text-error;
	}
</style>
